module.exports = __webpack_public_path__ + "img/lg_ring_g_i_0_1@2x.586d0e38.png";